import { useState } from 'react';
import { Link } from 'react-router-dom';

import { useCurrentUser } from '@/hooks';
import { PageHeaderLayout } from '@/ui';

import { republishCoachMatchingData } from '@/api/coachProfile';

// TODO: Manage pages should be simple, no extra components needed
const Manage = () => {
  useCurrentUser();
  const [message, setMessage] = useState('');
  const [isError, setIsError] = useState(false);

  const handleRepublishData = async () => {
    try {
      await republishCoachMatchingData();
      setMessage('Republish queued, check in a few minutes for updated data');
      setIsError(false);
    } catch (error) {
      setMessage('Republish failed. Try again or contact eng.');
      console.error(error);
      setIsError(true);
    }
  };

  return (
    <div className="container mx-auto max-w-screen-lg p-4">
      <PageHeaderLayout title="Manage" />

      <div className="mt-4 flex">
        <div className="flex w-1/2 flex-col gap-2">
          <Link className="text-cement-400 no-underline" to="cards">
            Cards
          </Link>
          <Link className="text-cement-400 no-underline" to="coaches">
            Coaches
          </Link>
          <Link className="text-cement-400 no-underline" to="companies">
            Companies
          </Link>
          <Link className="text-cement-400 no-underline" to="notifications">
            Notifications
          </Link>
          <Link className="text-cement-400 no-underline" to="templates">
            Templates
          </Link>
          <Link
            className="text-cement-400 no-underline"
            to="coach-ai-playground"
          >
            AI Playground
          </Link>
          <Link className="text-cement-400 no-underline" to="assistants">
            Assistants
          </Link>
        </div>

        <div className="flex w-1/2 flex-col items-center justify-start">
          <button
            className="rounded bg-blue-500 px-4 py-2 text-white hover:bg-blue-600"
            type="button"
            onClick={handleRepublishData}
          >
            Republish Coach Matching Data
          </button>

          {message && (
            <div
              className={`mt-2 rounded p-2 ${isError ? 'bg-red-100 text-red-700' : 'bg-green-100 text-green-700'}`}
            >
              {message}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Manage;
